// Smart Sash Admin Panel - Session List Component

import { Spinner } from '@/components/common';
import { ActiveSessionInfo, SessionAccessInfo } from '@/models/teaching.models';
import React from 'react';
import { SessionCard } from './SessionCard';

interface SessionListProps {
  sessions: ActiveSessionInfo[];
  accessChecks: Record<string, SessionAccessInfo>;
  isLoading: boolean;
  onJoin: (session: ActiveSessionInfo) => void;
}

export const SessionList: React.FC<SessionListProps> = ({
  sessions,
  accessChecks,
  isLoading,
  onJoin,
}) => {
  if (isLoading && sessions.length === 0) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner />
      </div>
    );
  }

  if (sessions.length === 0) {
    return (
      <div className="card">
        <div className="card-body text-center py-5">
          <i className="fas fa-video fa-3x text-muted mb-3 d-block" />
          <h5 className="text-muted">No Active Sessions</h5>
          <p className="text-muted mb-0">
            There are no live teaching sessions at the moment. Sessions will appear here when a
            presenter starts streaming.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="row g-3">
      {sessions.map((session) => (
        <div key={session.streamSessionId} className="col-12 col-md-6 col-xl-4">
          <SessionCard
            session={session}
            accessInfo={accessChecks[session.deviceId]}
            onJoin={onJoin}
          />
        </div>
      ))}
    </div>
  );
};
